import React, { useCallback, useRef } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { hitSlop, rem } from 'design-system/values';
import NavigationHeaderRightIconButton from 'design-system/NavigationHeaderRightIconButton';
import { useAccountMenu } from 'features/accounts/hooks/useAccountMenu';
import { IconSettings } from 'design-system/icons/IconSettings';
import useColors from 'hooks/useColors';
import Amplitude from 'utils/amplitude';
import { useAppSelector } from 'store/hooks';
import { selectUserId } from 'reducers/selectors';
import { isWeb } from '../../../../constants';
const AccountsHeaderRight = ({ account, navigation }) => {
    const colors = useColors();
    const userId = useAppSelector(selectUserId);
    const touchViewRef = useRef(null);
    const openMenu = useAccountMenu(navigation);
    const pressMenu = useCallback(() => {
        openMenu(account, touchViewRef);
        Amplitude.logEvent('Accounts.OpenAccountMenu');
    }, [account, openMenu]);
    if (userId !== account.userId)
        return null;
    return (<View ref={touchViewRef} style={styles.menuButton}>
      {isWeb ? (<NavigationHeaderRightIconButton onPress={pressMenu}>
          <IconSettings color={colors.text.primary}/>
        </NavigationHeaderRightIconButton>) : (<TouchableOpacity hitSlop={hitSlop} onPress={pressMenu}>
          <IconSettings color={colors.text.primary}/>
        </TouchableOpacity>)}
    </View>);
};
const styles = StyleSheet.create({
    menuButton: {
        ...(!isWeb && { marginLeft: rem(16) }),
    },
});
export default AccountsHeaderRight;
